import CubeIcon from "@/assets/icons/cube.svg";
import StatusPage, { StatusPageProps } from "@/containers/StatusPages";

const EmptyArchive: React.FunctionComponent<Partial<StatusPageProps>> = (
  props
) => {
  return (
    <StatusPage
      icon={CubeIcon}
      title={L.ARCHIVE_EMPTY_TITLE}
      subtitle={L.ARCHIVE_EMPTY_SUBTITLE}
      {...props}
    />
  );
};

export default EmptyArchive;
